import type React from 'react';
import ProfileAvatar from '../../../components/thumbnails/ProfileAvatar';
import type { BaseFootprint } from '../../../domain/models/locations/BaseFootprint';
import { ReactComponent as FixedIcon } from '../../../icons/fixed.svg';
import { VerfiedFill } from '@peacecover/icon';
import { useQueryParams } from '@pocapan/shared/utils/useQueryParams';

interface FootprintReportBoxProps {
  footprint: BaseFootprint;
  lotAddress: string;
}

const FootprintReportBox: React.FC<FootprintReportBoxProps> = ({ footprint, lotAddress }) => {
  const { updateQueryParams } = useQueryParams();

  const handleClick = () => {
    updateQueryParams(
      { locationId: footprint.footprintableId },
      '/report-location/footprints/already-reported',
      { state: { footprint, lotAddress } }
    );
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full bg-pure-white dark:bg-pure-black rounded-[12px] shadow-[0_0_0_1px_rgba(0,0,0,0.01),0_0_14px_0_rgba(0,0,0,0.08)]"
    >
      <div className="flex items-center gap-[6px] border-b border-separator1 px-[16px] pt-[16px] pb-[12px]">
        <ProfileAvatar
          profileImageUrl={
            footprint.reporter?.thumbnailUrl ?? '/assets/icons/thumbnail.ghost.profile.png'
          }
          widthAndHeight="18px"
          onClick={() => {}}
        />
        <div className="text-[14px] text-text-main-lv3">
          <span className="font-semibold mr-[2px] max-w-[130px] truncate">
            {footprint.reporter?.nickname}
          </span>
          님의 제보
        </div>
      </div>
      <div className="flex flex-row items-center w-full justify-between gap-[12px] px-[16px] pt-[12px] pb-[16px]">
        <div className="flex flex-col gap-[6px]">
          {footprint.contentType === 'official_content' && (
            <div className="w-full flex items-center gap-[4px]">
              <VerfiedFill size={14} className="text-on-varified" />
              <p className="font-medium text-[12px] text-on-varified">공식 컨텐츠에 나왔어요</p>
            </div>
          )}
          {footprint.description && (
            <p className="text-left text-[15px] text-text-main-lv2 whitespace-pre-wrap max-w-[200px] line-clamp-2 tracking-[0]">
              {footprint.description}
            </p>
          )}
        </div>
        {footprint.baseThumbnailUrl ? (
          <img
            src={footprint.baseThumbnailUrl}
            alt="Footprint"
            className="w-[83px] h-[60px] object-cover rounded-[10px]"
          />
        ) : (
          <div className="w-[83px] h-[60px] rounded-[10px] bg-gray-100 flex items-center justify-center">
            <FixedIcon className="w-[16px] h-[16px] fill-sub-light-2" />
          </div>
        )}
      </div>
    </button>
  );
};
export default FootprintReportBox;
